import React from 'react';

import StandaloneApp from './index';
import './App.css';
import session from '../session';
import EmbedFramework from '../EmbedFramework';
import localFcService from '../createLocalFcService';

const App = () => (
  <div className="App eventsui">
    <StandaloneApp>
      <div className="App-eventsui">
        <EmbedFramework session={session} apiUrl={`${process.env.REACT_APP_API_URL}`} fcService={localFcService()} />
      </div>
    </StandaloneApp>
  </div>
);

export default App;
